import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { colors } from "./colors";

const PROJECTS = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/wlux3p6y_grossraumbuero-led-panelbeleuchtung-arbeitsplatzbeleuchtung.png",
    projekt: "Büro",
    beschreibung: "Moderne LED Beleuchtung für Büroflächen mit gleichmäßiger Arbeitsplatzbeleuchtung und energieeffizienter Lichttechnik.",
    objektart: "Bürogebäude",
    beleuchtungssystem: "LED-Panelleuchten",
    lichtfarbe: "4000K Neutralweiß",
    besonderheit: "Human Centric Lighting",
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/dgn3jjqg_discounter-led-schienensystem-verkaufsraum.png",
    projekt: "Retail",
    beschreibung: "LED Beleuchtung für Verkaufsflächen und Handelsflächen mit optimaler Warenpräsentation.",
    objektart: "Einzelhandel",
    beleuchtungssystem: "LED-Schienensystem",
    lichtfarbe: "3000K/4000K kombiniert",
    besonderheit: "Warenspezifische Lichtakzente",
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/fwe241pa_produktionshalle-led-lichtsystem-industriebeleuchtung.png",
    projekt: "Industrie",
    beschreibung: "Installation von LED Beleuchtungssystemen in Produktionshallen und Industrieanlagen.",
    objektart: "Produktionshalle",
    beleuchtungssystem: "Industrieleuchten LED",
    lichtfarbe: "5000K Tageslichtweiß",
    besonderheit: "Hohe Gleichmäßigkeit 500 lx",
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/un2fswx6_logistikhalle-led-lichtbandinstallation-sanierung-industriebeleuchtung.png",
    projekt: "Logistik",
    beschreibung: "Montage energieeffizienter LED Lichtsysteme in Lagerhallen und Distributionszentren.",
    objektart: "Logistikhalle",
    beleuchtungssystem: "LED-Lichtbandsystem",
    lichtfarbe: "4000K Neutralweiß",
    besonderheit: "Sanierung im laufenden Betrieb",
  },
];

function ProjectCard({ project }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-gray-900">
        <img
          src={project.image}
          alt={project.projekt}
          className="w-full h-full object-cover transition-transform duration-700 ease-out"
          style={{ transform: isHovered ? "scale(1.05)" : "scale(1)" }}
        />
        <div
          className="absolute inset-0 transition-all duration-500"
          style={{ backgroundColor: isHovered ? "rgba(0,0,0,0.1)" : "rgba(0,0,0,0)" }}
        />
      </div>

      <div className="pt-5 pb-2">
        <h3 className="text-white font-semibold text-lg mb-4">{project.projekt}</h3>
        <p className="text-gray-400 text-sm leading-relaxed mb-4">{project.beschreibung}</p>
        <div
          className="text-sm"
          style={{
            display: "grid",
            gridTemplateColumns: "120px 1fr",
            rowGap: "6px",
            alignItems: "baseline",
          }}
        >
          <span className="text-gray-500">Objektart</span>
          <span className="text-gray-300">{project.objektart}</span>
          <span className="text-gray-500">System</span>
          <span className="text-gray-300">{project.beleuchtungssystem}</span>
          <span className="text-gray-500">Lichtfarbe</span>
          <span className="text-gray-300">{project.lichtfarbe}</span>
          <span className="text-gray-500">Besonderheit</span>
          <span className="text-gray-300">{project.besonderheit}</span>
        </div>
      </div>
    </div>
  );
}

export function ProjectsGrid() {
  const navigate = useNavigate();

  return (
    <section id="projekte" className="py-20 md:py-28 lg:py-32" style={{ backgroundColor: colors.anthracite }} data-testid="projects-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12 md:mb-16">
          <p className="text-blue-400/50 text-xs uppercase tracking-[0.2em] mb-3">Referenzen</p>
          <h2 className="text-white font-bold text-2xl md:text-3xl lg:text-4xl tracking-tight">
            Beispiel Projekte
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {PROJECTS.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}
